import { styled } from '../../theme';
import { Center } from '../Center';

export const Wrapper = styled(Center)`
	flex-direction: column;
`;
